import React, { useState, useRef, useEffect } from "react";
import { getLogonInfoFromCookies } from "../utils/util";

import { Box, TextField, Tooltip } from "@vapor/v3-components";
import {
  faArrowLeft,
  faXmark,
  faUser,
  faGrid,
} from "@fortawesome/pro-regular-svg-icons";
import {
  VaporThemeProvider,
  VaporPage,
  NotificationOverflow,
  AlertTitle,
  IconButton,
  VaporIcon,
  Title,
  ExtendedAvatar,
  Card,
  CardMedia,
  Spinner,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
  VaporUIShellNav,
  VaporAppBar,
  Uploader,
  Toast,
  NotificationInline,
  Stack,
} from "@vapor/v3-components";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { RootState } from "../store/store";
import { usePersistentState } from "../store/usePersistentState";
import { useWindowWidth } from "../utils/useWindowWidth";
import { getFileExtension } from "../utils/util";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import { FilterDetailsResponse } from "../services/Models/FilterDetailsModel";
import { RowFilterDocumentsResponse } from "../services/Models/DocumentsModel";
import { getFilterDetails } from "../services/filterDetailsService";
import { getDocuments } from "../services/documentListService";
// import DataGridPro from "@vapor/v3-components/DataGridPro";
import DmsDataGridPro from "../components/DmsDataGridPro";
import {
  GridColDef,
  GridColumnGroupingModel,
  GridColumnGroup,
  GridCellEditStopParams,
  GridSortModel,
  GridSortItem,
  GridCallbackDetails,
} from "@mui/x-data-grid-pro";
import {
  ColumnDescriptor,
  CmsFilterDetailRow,
  RowData,
} from "../services/Models/FilterDescriptorModel";

import { StandardColumns, retColumn } from "../components/StandardColumns";
import { Attached, Condition } from "../services/Models/BaseModel";
import { localFilter } from "../pages/Home";
import {
  IDmsPageResponse,
  getDefaultDmsPageRequest,
} from "../services/Models/DmsPagination";
import { AuthResponse } from "../services/Models/AuthModel";
import DmsDataGridProFunctions from "../components/DmsDataGridProFunctions";
import { downloadFile, getUrlPreview } from "../services/FileService";
import {
  FileDetailsRequest,
  FileDetailsResponse,
} from "../services/Models/DocumentsModel";
import { getFileDetails } from "../services/documentDetailsService";
import { ToolbarButtons } from "../components/ToolbarButtons";
import { uploadFile, deleteFile, documentSave } from "../services/FileService";
import { ListActions } from "../components/ListActions";
import { PreviewCard } from "./PreviewCard";
import { PreviewDocument } from "./PreviewDocument";
import { filterBreakpointKeys } from "@mui/system/Unstable_Grid/traverseBreakpoints";
import { returnError } from "../utils/util";
import { PagingInfo } from "../services/Models/BaseModel";
import { typography } from "@mui/system";
import { LocalStorageGridData } from "../components/DmsDataGridPro";
import { getSiteParameters } from "../services/siteParametersService";

export interface ShowFilterProps {
  currentFilter: localFilter;
  showIconsOrList: number; //0=nessun iconButton, 1=iconButton faList, 2=iconButton faGrid
  noTitle?: boolean;
  subtractHeight?: number;
  reloadFilterDetail?: number;
  closeFilter?: () => void;
}

type editedRow = {
  idObject: number;
  idDoc: number;
  descrizione: string;
  fileName: string;
};

type card = {
  idObject: number;
  image: string;
  title: string;
  doc: Attached;
  previewImage: string;
};

interface pageInfo extends PagingInfo {
  currentRows: number;
}

export const ShowFilter: React.FC<ShowFilterProps> = ({
  currentFilter,
  showIconsOrList,
  noTitle,
  subtractHeight,
  reloadFilterDetail,
  closeFilter,
}) => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    subCard: window.innerWidth < 1536 ? 50 : window.innerWidth < 1000 ? 70 : 90,
  });
  const presentActions = useRef<boolean>(false);
  const loginResult = useRef<AuthResponse>(getLogonInfoFromCookies());
  const reloadRequested = useRef<boolean>(false);
  const totDocInRow = useRef<number>(0);

  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  const requestPage = useRef<number>(1);

  //   const [showIconsOrList, setShowIconOrList] = useState<number>(
  //     localSiteParameters.current.Anteprima === "1" ? 1 : 0
  //   );
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const [saveOK, setSaveOK] = useState<string | null>(null);
  const [actionOK, setActionOK] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingUpload, setLoadingUpload] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [urlPreview, setUrlPreview] = useState<string>("");
  const [typePreview, setTypePreview] = useState<string | null>("");
  const [showDocuments, setShowDocuments] = useState<boolean>(false);
  const [showActions, setShowActions] = useState<boolean>(false);
  const [addableDocuments, setAddableDocuments] = useState<boolean>(false);
  const [errorUpload, setErrorUpload] = useState<string | undefined>(undefined);
  const [files, setFiles] = useState([]);
  const [idObjectActions, setIdObjectActions] = useState<number>(-1);
  const [arrayCards, setArrayCards] = useState<card[]>([]);
  const [pageInfo, setPageInfo] = useState<pageInfo>({
    currentRows: 0,
    PageSize: 0,
    TotalPages: 0,
    CurrentPage: 0,
  });

  // const [columns, setColumns] = useState<GridColDef[]>([]);
  // const [rows, setRows] = useState<GridColDef[]>([]);
  const [context, setContext] = useState("Filter_" + id);
  const [filterMode, setFilterMode] = useState(false);
  const calculateSortSearch = (): string => {
    const localStorageGridData: LocalStorageGridData = JSON.parse(
      localStorage.getItem(context) ?? "null"
    );
    if (localStorageGridData && localStorageGridData.sortModel) {
      return localStorageGridData.sortModel
        .map(
          (col: GridSortItem) =>
            `${col.field}:${col.sort === "asc" ? "ASC" : "DESC"}`
        )
        .join(";");
    }
    return "";
  };
  const sortSearch = useRef<string>(calculateSortSearch());
  const conditionsSearch = useRef<Condition[]>([]);
  const quickFilter = useRef("");
  const columns = useRef<GridColDef[]>([]);
  const docList = useRef<Attached[]>([]);
  const [data, setData] = useState<any>({
    columns: [],
    rows: [],
    pageRequest: getDefaultDmsPageRequest(),
    pageResponse: null,
  });
  const [editedDescriptions, setEditedDescriptions] = useState<editedRow[]>([]);
  const [dataDocuments, setDataDocuments] = useState<any>({
    columns: [],
    rows: [],
    pageRequest: getDefaultDmsPageRequest(),
    pageResponse: null,
  });
  const [columnGroupingModel, setColumnGroupingModel] =
    useState<GridColumnGroupingModel>([]);
  const selectedRow = useRef<number>(-1);

  const onDownloadFile = (idRow: number, type?: string, row?: any) => {
    selectedRow.current = idRow;
    if (loginResult.current && loginResult.current.SecurityToken && !loading) {
      const resDoc = docList.current.filter(
        (doc: Attached) =>
          doc.IdObject === row.idObject && doc.IdDoc === row.idDoc
      );
      if (resDoc.length > 0) {
        if ((type ?? "show") === "preview") {
          showPreviewDocument(resDoc[0]);
        } else {
          downloadFile(
            row.fileName,
            row.idObject,
            row.idDoc,
            row.MD5,
            (type ?? "show") === "show" ? true : false,
            row.tipoDocumento
          );
        }
      }
    }
  };

  const showPreviewDocument = async (doc: Attached) => {
    setLoading(true);
    try {
      if (!doc) {
        setError(t("no-docs"));
        return;
      }
      if (doc.DocumentType === "LINK" || doc.DocumentType === "YOUTUBE") {
        setTypePreview(doc.DocumentType);
        setUrlPreview(doc.LinkUrl);
        setShowPreview(true);
        return;
      }

      // Chiamata asincrona
      const result: FileDetailsResponse = await getFileDetails(
        loginResult.current.SecurityToken,
        loginResult.current.Language ?? "it",
        doc.IdObject,
        doc.IdDoc,
        doc.FileNameUrl,
        doc.MD5,
        doc.FileContent
      );
      if (result && result.ResultCode !== "ERROR") {
        console.log("getFileDetails successful:");
        setTypePreview(result.DocumentType);
        setUrlPreview(window.config.BASE_URL + "/preview/" + result.FileName);
        setShowPreview(true);
      } else {
        setError(t(returnError(result)));
        console.error("getFileDetails Error :", "no result");
      }
    } catch (error) {
      setError(t("errore interno"));
      console.error("getFileDetails Error :", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteDocument = async (idDoc: number) => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken && !loading) {
      setLoadingUpload(true);
      try {
        const result: FileDetailsResponse = await deleteFile(
          loginResult.SecurityToken,
          selectedRow.current,
          idDoc
        );
        if (result && result.ResultCode !== "ERROR") {
          if (!currentFilter.LinkedDocs) {
            totDocInRow.current = totDocInRow.current - 1;
          }
          setDataDocuments((prevDataDocuments: any) => ({
            ...prevDataDocuments,
            rows: prevDataDocuments.rows.filter(
              (row: any) => row.idDoc !== idDoc
            ),
          }));
        } else {
          setError(t(returnError(result)));
        }
      } catch (error) {
        setError(t("errore interno"));
      } finally {
        setLoadingUpload(false);
      }
    }
  };

  const columnsDoc: GridColDef[] = [
    StandardColumns.id(),
    StandardColumns.idDoc(),
    StandardColumns.idObject(),
    StandardColumns.fileName(
      { onClickIcon: onDownloadFile },
      currentFilter.noDownloadVideo
    ),
    StandardColumns.descrizione({ editable: true }),
    StandardColumns.tipoDocumento(),
    StandardColumns.dimensione(),
    StandardColumns.MD5(),
    StandardColumns._actions_({ onClickIcon: deleteDocument }),
  ];

  useEffect(() => {
    dmsDataFunction();
  }, [currentFilter]);

  useEffect(() => {
    if (reloadFilterDetail && reloadFilterDetail > 0) {
      requestPage.current = 1;
      reloadRequested.current = true;
      dmsDataFunction();
    }
  }, [reloadFilterDetail]);

  const dmsDataFunction = async () => {
    setLoading(true);
    try {
      if (reloadRequested.current) {
        reloadRequested.current = false;
        const resultSite: SiteParametersResponse = await getSiteParameters(
          null
        );
        if (resultSite && resultSite.ResultCode !== "ERROR") {
          localSiteParameters.current = resultSite;
          if (localSiteParameters.current.Visualizzazione === "continuo") {
            navigate("/presentationPage");
          }
        } else {
          setError("LoadSiteParameters : " + t("errore interno"));
          console.error("LoadSiteParameters Error :", "no result");
          setLoading(false);
          return;
        }
      }
      // Chiamata asincrona
      const result: IDmsPageResponse<FilterDetailsResponse> =
        await getFilterDetails(
          loginResult.current.SecurityToken,
          loginResult.current.Language ?? "it",
          currentFilter.filterId,
          currentFilter.idObject,
          requestPage.current,
          0, //data.pageRequest.pageSize,
          // undefined,
          quickFilter.current,
          "",
          sortSearch.current,
          conditionsSearch.current
        );
      if (result && result.data[0].ResultCode !== "ERROR") {
        if (result.data[0].PagingInfo.RecordCount === 0) {
          setSaveOK(t("no-filter-data"));
          setData({
            ...data,
            rows: [],
          });
        } else {
          console.log("getFiter successful:");
          let appRows = result.data[0].Rows.map((row: CmsFilterDetailRow) => {
            if (row.FlagAzioniPresenti) presentActions.current = true;
            return loadRow(row);
          });
          if (currentFilter.idObject) {
            showPreviewDocument(result.data[0].Rows[0].Doc);
          }
          if (result.data[0].PagingInfo.CurrentPage > 1) {
            appRows = [...data.rows, ...appRows];
          }

          if (localSiteParameters.current.Anteprima === "1") {
            let appCards = result.data[0].Rows.map(
              (row: CmsFilterDetailRow) => {
                return {
                  idObject: row.IdObject,
                  image: row.DocImage,
                  title: row.Title,
                  doc: row.Doc,
                  previewImage: row.DocImage,
                };
              }
            );
            if (result.data[0].PagingInfo.CurrentPage > 1) {
              appCards = [...arrayCards, ...appCards];
            }
            setArrayCards(appCards);
          }
          const hiddenFields: string[] = loadColumns(
            result.data[0].FilterDescriptor.Columns
          );
          if (!presentActions.current) hiddenFields.push("action");

          let newColumnVisibilityModel =
            DmsDataGridProFunctions.getViewColumnVisibilityModel(
              columns.current
            );
          setData({
            columns: columns.current,
            columnVisibilityModel: newColumnVisibilityModel,
            rows: appRows,
            pageRequest: {
              page: 1,
              pageSize: 5,
              searchText: "",
              searchFilters: [],
              orderBy: [],
            },
            pageResponse: result,
          });
          setPageInfo({
            ...result.data[0].PagingInfo,
            currentRows: appRows.length,
            // result.data[0].PagingInfo.CurrentPage > 1
            //   ? data.rows.length + result.data[0].Rows.length
            //   : result.data[0].Rows.length,
          });
          if (context !== "Filter_" + currentFilter.filterId.toString())
            setContext("Filter_" + currentFilter.filterId.toString());
        }
        if (
          conditionsSearch.current.length === 0 &&
          quickFilter.current === ""
        ) {
          if (
            result.data[0].PagingInfo.CurrentPage <
            (result.data[0].PagingInfo.TotalPages ??
              result.data[0].PagingInfo.CurrentPage)
          )
            setFilterMode(true);
          else {
            setFilterMode(false);
          }
        }
      } else {
        setError(t("errore interno"));
        console.error("getFiter Error :", "no result");
      }
    } catch (error) {
      setError(t("errore interno"));
      console.error("getFiter Error :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (!loginResult.current) navigate("/");

    // if (loginResult.current && loginResult.current.SecurityToken && !loading) {
    //   dmsDataFunction();
    // }
    const handleResize = () => {
      setDimensions({
        width:
          window.innerWidth < 1536 ? window.innerWidth + 32 : window.innerWidth,
        height:
          window.innerWidth < 1536
            ? window.innerHeight // + 32
            : window.innerHeight,
        subCard:
          window.innerWidth < 1536 ? 50 : window.innerWidth < 1000 ? 70 : 90,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const loadRow = (row: CmsFilterDetailRow) => {
    const obj: any = {};
    obj["id"] = row.IdObject;
    obj["file"] =
      String(currentFilter.LinkedDocs ? 9999 : row.NumDocs) +
      "," +
      (row.Doc ? row.Doc.DocumentType : "");
    obj["action"] = row.FlagAzioniPresenti;
    row.Values.filter((value) => value.ColumnName !== "FileCount").map(
      (value: RowData) => {
        var colName = value.ColumnName;
        if (colName === "StatusColor") {
          obj[colName] = row.StatusColor + "," + row.StatusName;
        } else {
          if (value.DataText == null) {
            if (row.hasOwnProperty(value.ColumnName)) {
              obj[colName] = (row as any)[value.ColumnName] ?? "";
            }
          } else obj[colName] = value.DataText;
        }
      }
    );
    // obj["Documents"] = RetriveDoc(e);
    // obj["Actions"] = RetriveAction(e);
    return obj;
  };

  const dmsDataFunctionDocuments = async () => {
    setLoading(true);
    try {
      // Chiamata asincrona
      const result: IDmsPageResponse<RowFilterDocumentsResponse> =
        await getDocuments(
          loginResult.current.SecurityToken,
          loginResult.current.Language ?? "it",
          Number(id),
          selectedRow.current,
          //   showIconsOrList === 1
          false
        );
      if (result && result.data[0].ResultCode !== "ERROR") {
        console.log("getFiter successful:");
        docList.current = result.data[0].Docs;
        setAddableDocuments(result.data[0].bFiltroDocNew);
        const docs = result.data[0].Docs.map((doc: Attached, index: number) => {
          const obj: any = {};
          obj["id"] = index;
          obj["idDoc"] = doc.IdDoc;
          obj["idObject"] = doc.IdObject;
          obj["fileName"] =
            doc.DocumentType === "LINK" || doc.DocumentType === "YOUTUBE"
              ? doc.LinkUrl
              : doc.FileName;
          obj["descrizione"] = doc.FileDescr;
          obj["tipoDocumento"] = doc.DocumentType;
          obj["dimensione"] = doc.FileSize;
          obj["_actions_"] = doc.DocEdit;
          obj["MD5"] = doc.MD5;
          return obj;
        });
        if (!currentFilter.LinkedDocs) {
          totDocInRow.current = docs.length;
        }
        let newColumnVisibilityModel =
          DmsDataGridProFunctions.getViewColumnVisibilityModel(columnsDoc);

        setDataDocuments({
          columns: columnsDoc,
          columnVisibilityModel: newColumnVisibilityModel,
          rows: docs,
          pageRequest: {
            page: 1,
            pageSize: undefined,
            searchText: "",
            searchFilters: [],
            orderBy: [],
          },
          pageResponse: result,
        });
        setShowDocuments(true);
      } else {
        setError(t("errore interno"));
        console.error("getFiter Error :", "no result");
      }
    } catch (error) {
      setError(t("errore interno"));
      console.error("getFiter Error :", error);
    } finally {
      setLoading(false);
    }
  };

  const onClickFile = (idRow: number) => {
    selectedRow.current = idRow;
    readNumDocInGrid(selectedRow.current);
    if (loginResult.current && loginResult.current.SecurityToken && !loading) {
      dmsDataFunctionDocuments();
    }
  };

  const onClickAction = (idRow: number) => {
    setIdObjectActions(idRow);
    setShowActions(true);
  };

  const onCloseAction = (actionExecuted: boolean, actionName?: string) => {
    setIdObjectActions(0);
    setShowActions(false);
    if (actionExecuted) {
      setActionOK(t("action") + " " + actionName);
      dmsDataFunction();
    }
  };

  const loadColumns = (colDesc: ColumnDescriptor[]) => {
    const cols: GridColDef[] = [
      StandardColumns.id(),
      StandardColumns.file({ onClickIcon: onClickFile }),
      StandardColumns.action({ onClickIcon: onClickAction }),
      ...colDesc
        .filter((col) => col.ColumnId !== "FileCount")
        .flatMap((col: ColumnDescriptor) => {
          if (col.SubColumnsCount > 0 && col.SubColumns) {
            // Converti tutte le subcolumns e le restituisci
            return col.SubColumns.map((subCol: ColumnDescriptor) =>
              retColumn(subCol)
            );
          } else {
            // Restituisci la colonna corrente
            return [retColumn(col)];
          }
        }),
    ];
    let group: GridColumnGroup[] = [];
    let hiddenFields: string[] = [];
    colDesc.forEach((col: ColumnDescriptor) => {
      if (!col.Show) hiddenFields.push(col.ColumnId);
      if (col.SubColumnsCount > 0 && col.SubColumns) {
        // Converti tutte le subcolumns e le restituisci
        const children = col.SubColumns.map((subCol: ColumnDescriptor) => {
          return { field: subCol.ColumnId };
        });
        group.push({
          groupId: col.LanguageLabel,
          children,
        });
      }
    });
    setColumnGroupingModel(group);
    columns.current = cols;
    // setColumns(cols);
    return hiddenFields;
  };
  const returnHome = () => {
    if (
      localSiteParameters.current.Visualizzazione === "continuo" &&
      closeFilter
    )
      closeFilter();
    else navigate("/home");
  };

  const readNumDocInGrid = (idRow: number) => {
    if (selectedRow.current >= 0 && data.rows.length > 0) {
      data.rows.forEach((row: any) => {
        if (row.id === selectedRow.current) {
          // Estraggo il tipo di file dalla colonna "file"
          const fileParts = row.file.split(","); // Divide la colonna "file" in [numero documenti, tipo file]
          totDocInRow.current = isNaN(Number(fileParts[0]))
            ? 0
            : Number(fileParts[0]);
        }
      });
    }
  };

  const updateNumDocInGrid = () => {
    if (selectedRow.current >= 0 && data.rows.length > 0) {
      let preTotDocs = 0;
      // Trova la riga selezionata e aggiorna i dati
      const rows = [...data.rows].map((row) => {
        if (row.id === selectedRow.current) {
          // Estraggo il tipo di file dalla colonna "file"
          const fileParts = row.file.split(","); // Divide la colonna "file" in [numero documenti, tipo file]
          preTotDocs = isNaN(Number(fileParts[0])) ? 0 : Number(fileParts[0]);
          const fileType = fileParts[1] || ""; // Tipo di file (seconda parte dopo la virgola)
          return {
            ...row,
            file: `${String(
              currentFilter.LinkedDocs ? 9999 : totDocInRow.current
            )},${fileType}`, // Aggiorno il numero di documenti
          };
        }
        return row;
      });
      if (preTotDocs !== totDocInRow.current) setData({ ...data, rows: rows });
    }
  };
  const saveDocuments = async () => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken) {
      try {
        setLoadingUpload(true);
        const results = await Promise.allSettled(
          editedDescriptions.map(async (row: editedRow) => {
            const result: FileDetailsResponse = await documentSave(
              loginResult.SecurityToken,
              row.idObject,
              row.idDoc,
              row.descrizione
            );
            if (result.ResultCode === "ERROR") {
              throw new Error(
                t("errore interno") +
                  " " +
                  row.fileName +
                  " " +
                  result.DetailedMessage
              );
            }
            return result;
            // if (result && result.ResultCode === "ERROR") {
            //   setError(t("errore interno") + " " + result.DetailedMessage);
            // }
          })
        );

        const errors = results
          .filter((result) => result.status === "rejected")
          .map((result) => (result as PromiseRejectedResult).reason);
        if (errors.length > 0) {
          setError(errors.join("\n")); // Unisco gli errori con newline
        } else {
          setSaveOK(t("salva-descrizioni"));
          setEditedDescriptions([]);
        }
      } catch (error) {
        setError(t("errore interno") + " " + error);
        console.error("UploadFile Error :", error);
      } finally {
        setLoadingUpload(false);
      }
    }
  };

  const uploadDocument = async (
    idObject: number,
    fileName: string,
    file: any
  ) => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken) {
      try {
        const result: FileDetailsResponse = await uploadFile(
          loginResult.SecurityToken,
          idObject,
          fileName,
          "",
          file
        );
        if (result && result.ResultCode === "ERROR") {
          setError(t("errore interno") + " " + result.DetailedMessage);
        }
      } catch (error) {
        setError(t("errore interno") + " " + error);
        console.error("UploadFile Error :", error);
      }
    }
  };

  const onFileUpload = async (filesItems: any) => {
    if (filesItems.length > 0) {
      if (filesItems.length > 0) {
        try {
          setLoadingUpload(true);
          await Promise.all(
            filesItems.map((file: any) =>
              uploadDocument(selectedRow.current, (file as any).name, file)
            )
          );
        } catch (error) {
          console.error("Error during file upload:", error);
        } finally {
          await dmsDataFunctionDocuments();
          setLoadingUpload(false);
        }
      }
      // setActiveSave(true);
    }
  };

  const handleEditCellChange = (newRow: any, oldRow: any) => {
    if (newRow.descrizione !== oldRow.descrizione) {
      const newEditedRow: editedRow = {
        idObject: newRow.idObject,
        idDoc: newRow.idDoc,
        descrizione: newRow.descrizione,
        fileName: newRow.fileName,
      };
      const editedDescriptionsArray = [...editedDescriptions];
      const existingIndex = editedDescriptionsArray.findIndex(
        (editedRow: any) =>
          editedRow.idObject === newEditedRow.idObject &&
          editedRow.idDoc === newEditedRow.idDoc
      );
      if (existingIndex !== -1) {
        // Se esiste, aggiorno la descrizione
        editedDescriptionsArray[existingIndex].descrizione =
          newEditedRow.descrizione;
      } else {
        // Altrimenti aggiungo il nuovo elemento
        editedDescriptionsArray.push(newEditedRow);
      }
      setEditedDescriptions(editedDescriptionsArray);
    }
  };

  const dialogDocuments = () => {
    return (
      <Dialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        fullWidth={true}
        maxWidth={"lg"}
        open={showDocuments}
        // sx={{
        //   minWidth: "400px",
        // }}
      >
        <DialogTitle>
          {t("doc-list")}
          <IconButton
            color="primary"
            onClick={() => {
              setShowDocuments(false);
              updateNumDocInGrid();
            }}
            variant="text"
            // sx={{
            //   "& .MuiDialog-paper": {
            //     width: "50%", // Imposta la larghezza al 50% della pagina
            //     maxWidth: "none", // Permette di ignorare il valore predefinito di maxWidth
            //   },
            // }}
          >
            <VaporIcon icon={faXmark} size="s" color="primary" />
          </IconButton>
        </DialogTitle>
        <Divider variant="fullWidth" />
        <DialogContent
          sx={{
            minHeight: "470px",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
          }}
        >
          {/* <Box
            sx={{
              width: `${(dimensions.width * dimensions.subCard) / 100}px`,
              height: `${(dimensions.height * dimensions.subCard) / 100}px`,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          > */}
          <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <DmsDataGridPro
              contextId={"documents"}
              dmsDataFunction={dmsDataFunctionDocuments}
              data={dataDocuments}
              // rows={rowsDocuments}
              // columns={columnsDocuments.current}
              pagination={false}
              isCellEditable={(params) => params.row._actions_}
              sx={{
                margin: 1,
                overflow: "auto", // Abilita lo scrolling automatico
                flexGrow: 1, // Occupa lo spazio disponibile nel contenitore
                minHeight: 310, // Imposta un'altezza minima per evitare il taglio dell'empty state
                maxHeight: "100%",
              }}
              processRowUpdate={handleEditCellChange}
              noExport={dimensions.width < 600 ? true : false}
              // initialState={{
              //   pinnedColumns: {
              //     left: ["id", "idPublication"],
              //     right: ["delete"],
              //   },
              // }}
            />
          </Box>
          {addableDocuments && (
            <Uploader
              buttonLabel={t("selectFile")}
              draggableText={t("dragFile")}
              dropText={t("dropFile")}
              description={t("trascina")}
              buttonVariant="outlined"
              errorMessage={errorUpload}
              draggable
              error={true}
              disabled={false}
              onFileUpload={onFileUpload}
              inputFileProps={{
                multiple: true,
              }}
              files={files}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              mr: 1,
            }}
            onClick={() => {
              setShowDocuments(false);
              updateNumDocInGrid();
            }}
          >
            {t("cancel")}{" "}
          </Button>
          <Button
            sx={{
              mr: 1,
            }}
            variant="contained"
            onClick={() => {
              saveDocuments();
            }}
            disabled={editedDescriptions.length === 0}
          >
            {t("save")}
          </Button>
          {loadingUpload && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
              }}
            >
              <Spinner size={64} />
            </Box>
          )}
        </DialogActions>
        <Toast
          open={saveOK ? true : false}
          anchorOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          autoHideDuration={2000}
          onClose={() => setSaveOK(null)}
        >
          <NotificationInline
            severity="success"
            onClose={() => setSaveOK(null)}
          >
            <AlertTitle>{saveOK}</AlertTitle>
            {t("saveOK")}
          </NotificationInline>
        </Toast>
      </Dialog>
    );
  };
  const showDocument = () => {
    return (
      <PreviewDocument
        showPreview={showPreview}
        typePreview={typePreview ?? ""}
        urlPreview={urlPreview}
        noDownloadVideo={currentFilter.noDownloadVideo}
        closePreview={() => {
          setShowPreview(false);
        }}
      />
    );
  };
  const handleClickCard = (doc: Attached) => {
    showPreviewDocument(doc);
  };

  const handleLoadOther = () => {
    requestPage.current += 1;
    dmsDataFunction();
  };
  const onSortModelChange = (
    newModel: GridSortModel,
    details: GridCallbackDetails
  ) => {
    let newSortSearch: string = "";
    newModel.forEach((col: GridSortItem) => {
      newSortSearch +=
        (newSortSearch !== "" ? ";" : "") +
        col.field +
        ":" +
        (col.sort === "asc" ? "ASC" : "DESC");
    });
    sortSearch.current = newSortSearch;
    requestPage.current = 1;
    dmsDataFunction();
  };
  const onFilterModelChange = (
    conditions: Condition[],
    quickSearch: string
  ) => {
    quickFilter.current = quickSearch;
    conditionsSearch.current = conditions;
    requestPage.current = 1;
    dmsDataFunction();
  };
  return (
    <Box
      id="box-container"
      sx={{
        bgcolor: "strateLayer2",
        //        width: `${dimensions.width - 50}px`,
        width: "100%",
        height: `${
          dimensions.height -
          60 -
          (subtractHeight ?? 0) +
          (localSiteParameters.current.Banner !== "0" ? 0 : 48)
        }px`,
        overflow: "auto",
      }}
    >
      <VaporPage
        {...(localSiteParameters.current.Anteprima === "1"
          ? {
              sx: {
                bgcolor: "strateLayer2",
              },
            }
          : {})}
      >
        {(noTitle ?? false) === false && (
          <Title
            divider
            leftItems={[
              <IconButton
                onClick={(e) => returnHome()}
                edge="end"
                sx={{ padding: 0 }}
              >
                <VaporIcon icon={faArrowLeft} size="s" color="primary" />
              </IconButton>,
            ]}
            title={currentFilter.filterName}
            size={dimensions.height > 500 ? "small" : "extraSmall"}
          />
        )}
        <Box
          id="grid-box"
          sx={{
            width: `${dimensions.width - 50}px`,
            height: `${
              dimensions.height -
              160 + //145 +
              (noTitle ?? false ? 65 : 0) -
              (subtractHeight ?? 0) +
              (localSiteParameters.current.Banner !== "0" ? 0 : 48)
            }px`,
            minHeight: "350px",
            display: "flex",
            flexDirection: "column",
            //            overflow: "hidden",
            overflowY: "auto",
            position: "relative",
          }}
        >
          {(localSiteParameters.current.Anteprima === "1" ||
            localSiteParameters.current.Visualizzazione === "continuo") &&
          showIconsOrList === 1 ? (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
                justifyContent: "space-evenly", // Allinea centralmente
                //justifyContent: "flex-start", // Allinea le card a sinistra
                padding: "16px",
                overflowY: "auto", // Attiva lo scroll verticale
                maxHeight: "100vh", // Limita l'altezza massima alla viewport
                marginBottom: `${
                  localSiteParameters.current.Anteprima === "1" &&
                  pageInfo.CurrentPage <
                    (pageInfo.TotalPages ?? pageInfo.CurrentPage)
                    ? 30
                    : 0
                }px`,
              }}
            >
              {arrayCards.map((card: card, index: number) => {
                return (
                  <PreviewCard
                    title={card.title}
                    image={card.image}
                    previewImage={card.previewImage}
                    index={index}
                    doc={card.doc}
                    noDownloadVideo={currentFilter.noDownloadVideo}
                    onClick={() => handleClickCard(card.doc)}
                  />
                );
              })}
            </Box>
          ) : (
            <DmsDataGridPro
              contextId={context}
              dmsDataFunction={dmsDataFunction}
              data={data}
              columnGroupingModel={columnGroupingModel}
              pagination={false}
              // filterMode={
              //   pageInfo.CurrentPage <
              //   (pageInfo.TotalPages ?? pageInfo.CurrentPage)
              // }
              filterMode={filterMode}
              onSortModelChange={
                // pageInfo.CurrentPage <
                // (pageInfo.TotalPages ?? pageInfo.CurrentPage)
                filterMode ? onSortModelChange : undefined
              }
              onFilterModelChange={filterMode ? onFilterModelChange : undefined}
              noExport={dimensions.width < 600 ? true : false}
              // initialState={{
              //   pinnedColumns: {
              //     left: ["id", "file", "action"],
              //     right: [],
              //   },
              // }}
              // contentleft={
              //   <>
              //     <Button size="small">Mark as Confirmed</Button>
              //     <Button size="small">Send E-mail</Button>
              //     <Button size="small" color="error">
              //       Delete
              //     </Button>
              //     <Button
              //       ref={anchorEl}
              //       size="small"
              //       startIcon={<VaporIcon icon={faAngleDown} />}
              //       aria-controls={open ? "basic-menu" : undefined}
              //       aria-haspopup="true"
              //       aria-expanded={open ? "true" : undefined}
              //       onClick={() => setOpen(true)}
              //     >
              //       Batch actions
              //     </Button>
              //     <Menu
              //       id="basic-menu"
              //       anchorEl={anchorEl.current}
              //       open={open}
              //       onClose={() => setOpen(false)}
              //       MenuListProps={{
              //         "aria-labelledby": "basic-button",
              //       }}
              //     >
              //       <MenuItem onClick={() => callTest()}>
              //         Create Shipments
              //       </MenuItem>
              //       <MenuItem onClick={() => setOpen(false)}>
              //         Convert to Invoice
              //       </MenuItem>
              //       <MenuItem onClick={() => setOpen(false)}>
              //         Merge Sales Orders
              //       </MenuItem>
              //     </Menu>{" "}
              //   </>
              // }
              // checkboxSelection
            />
          )}
          {pageInfo.CurrentPage <
            (pageInfo.TotalPages ?? pageInfo.CurrentPage) && (
            <Box
              sx={{
                position: "absolute", // Posiziona il contenitore del pulsante
                top: `${
                  dimensions.height -
                  (localSiteParameters.current.Anteprima === "1" ? 173 : 190)
                }px`,
                // left: "0px",
                left: "50%", // Centra orizzontalmente
                transform: "translateX(-50%)", // Compensa il 50% della larghezza per centrare il pulsante
                width: `${
                  localSiteParameters.current.Anteprima === "1"
                    ? "100%"
                    : undefined
                }`,
              }}
              bgcolor={
                localSiteParameters.current.Anteprima === "1"
                  ? "white"
                  : undefined
              }
            >
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  alignItems: "center",
                  // backgroundColor: "hsla(215, 15%, 97%, 0.5)",
                  // border: "1px solid #ddd",
                  justifyContent: "space-between",
                }}
              >
                <Button size="small" variant="text" onClick={handleLoadOther}>
                  {t("Carica altri elementi")}
                </Button>
                {localSiteParameters.current.Anteprima === "1" && (
                  <Typography
                    component="div"
                    gutterBottom
                    variant="bodySmallRegular"
                  >
                    Record totali: {pageInfo.currentRows} di{" "}
                    {pageInfo.RecordCount}
                  </Typography>
                )}
              </Stack>
            </Box>
          )}
        </Box>
        {dialogDocuments()}
        {showDocument()}
        <ListActions
          idFilter={Number(id)}
          idObject={idObjectActions}
          open={showActions}
          onClose={onCloseAction}
        />
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
        {error && (
          <NotificationOverflow severity="error" onClose={() => setError(null)}>
            <AlertTitle>{t("error-header")}</AlertTitle>
            {error}
          </NotificationOverflow>
        )}
        <Toast
          open={actionOK ? true : false}
          anchorOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          autoHideDuration={2000}
          onClose={() => setActionOK(null)}
        >
          <NotificationInline
            severity="success"
            onClose={() => setActionOK(null)}
          >
            <AlertTitle>{saveOK}</AlertTitle>
            {t("actionOK")}
          </NotificationInline>
        </Toast>
      </VaporPage>
    </Box>
  );
};
